import { render, staticRenderFns } from "./LocationTree.vue?vue&type=template&id=10b75ab8&scoped=true"
import script from "./LocationTree.vue?vue&type=script&lang=js"
export * from "./LocationTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b75ab8",
  null
  
)

export default component.exports